import home from './home';

export const homeActions = home.actions;
export const homeReducer = home.reducer;
